// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".chart-container{overflow:hidden;padding:0!important}.kit-metric{max-width:100%}.kit-metric .e-card__title{margin-bottom:0}.expanded-chart-dialog{overflow-y:hidden}.expanded-chart-dialog:not(.expanded-chart-dialog--mobile) .v-card>.v-card__text{height:calc(100% - 3rem)!important;padding:3rem 2rem!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
